export const QuestSuperType = 'Quest';
export var QuestType;
(function (QuestType) {
    QuestType[QuestType["Artefact"] = 0] = "Artefact";
    QuestType[QuestType["HeroicTrait"] = 1] = "HeroicTrait";
    QuestType[QuestType["Prayer"] = 2] = "Prayer";
    QuestType[QuestType["Spell"] = 3] = "Spell";
    QuestType[QuestType["Manifestation"] = 4] = "Manifestation";
    QuestType[QuestType["RenownPoints"] = 5] = "RenownPoints";
    QuestType[QuestType["Unknown"] = 99] = "Unknown";
})(QuestType || (QuestType = {}));
